/* istanbul ignore file */
import { oneOf as codecOneOf } from 'purify-ts/Codec';
import { ImpersonateData } from './ImpersonateData';
import { LoginData } from './LoginData';
const LoginUserDataParser = /* #__PURE__ */ /* #__PURE__ */ codecOneOf([
    LoginData,
    ImpersonateData,
]);
export const LoginUserData = LoginUserDataParser;
